import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import * as React from "react";
import { Button, Confirm, required, TextInput, useNotify } from "react-admin";
import { Form } from "react-final-form";
import appDataProvider from "../../../dataprovider";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import { ReliabilityReportType } from "../../../Enums/ReliabilityReportType";
const ReliabilityManualThyCreate = ({ isOpen, onClose, reportType, ...rest }) => {
  const { http } = appDataProvider;
  const [questOpen, setQuestOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  var notify = useNotify();

  const handleClose = () => {
    setLoading(false);
    onClose?.();
  };
  const handleSubmit = values => {
    setLoading(true);
    isExclusionPn(values.batch, values.acRemoveDate);
  };
  const isExclusionPn = (batch, acRemoveDate) => {
    var values = { batch: batch, acRemoveDate: acRemoveDate, reportType: reportType };
    http
      .post("reliabilityreports/isexclusionpnbythyrequest", values)
      .then(result => {
        if (result?.data === true) {
          setQuestOpen(true);
        } else {
          create(values);
        }
      })
      .catch(error => {
        console.log(error);
        create(values);
      });
  };
  const create = values => {
    http
      .post("reliabilityreports/thymanualcreate", { ...values })
      .then(result => {
        if (result?.data !== undefined && result?.data !== null) {
          notify(`Successfully completed`, "success", false, true);
          handleClose();
        } else {
          notify("Operation failed. Please try again.", "error", false, true);
          handleClose();
        }
      })
  };
  const onConfirmQuest = values => e => {
    create(values);
    onCloseQuest();
  };
  const onCloseQuest = () => {
    setQuestOpen(false);
    setLoading(false);
  };
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{ type: 1, reportType: reportType }}
      render={({ handleSubmit, form, submitting, pristine, values, invalid }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Confirm
            isOpen={questOpen}
            title={""}
            content={"Do you want to create a record with an excluded pn?"}
            confirm={"Approve"}
            cancel={"Cancel"}
            onConfirm={onConfirmQuest(values)}
            onClose={onCloseQuest}
          />
          <Dialog open={isOpen} fullWidth={true} maxWidth={"xs"} onClose={handleClose}>
            <DialogTitle id="confirmation-dialog-title">
              {reportType === ReliabilityReportType.ThyFailOnFit ? "Create Fail On Fit" : "Create Premature Failure"}
            </DialogTitle>
            <DialogContent dividers>
              <Grid container>
                <Grid item xs={12}>
                  <TextInput source="batch" label="Batch" fullWidth validate={required()} variant="outlined" />
                </Grid>
                <Grid item xs={12}>
                  <CustomDatetime
                    source="acRemoveDate"
                    label="AC Remove Date"
                    fullWidth
                    validate={required()}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" label="Close" onClick={handleClose} disabled={loading} color="default" />
              <Button
                variant="contained"
                label="Submit"
                type="submit"
                onClick={handleSubmit}
                disabled={loading || invalid}
                color="primary"
              />
            </DialogActions>
          </Dialog>
        </form>
      )}
    />
  );
};

export default ReliabilityManualThyCreate;
